import React, {useCallback, useEffect, useMemo} from 'react';
import {useSelector} from "react-redux";
import lodash from 'lodash';
import DatePicker from 'react-datepicker';
import {useList} from 'react-use';
import moment from 'moment';

import '../styles.scss';
import Checkbox from "../../../../components/checkbox";
import {TOTAL_DETAIL} from './constant';

function SelectPeriod(props) {
    const {selected, onChange} = props;
    const years = useSelector(state => state.metadata.years);

    const [listMonth] = useList([
        {
            id: 3,
            name: '3月',
        },{
            id: 4,
            name: '4月',
        },{
            id: 5,
            name: '5月',
        },{
            id: 6,
            name: '6月',
        },{
            id: 7,
            name: '7月',
        },{
            id: 8,
            name: '8月',
        },{
            id: 9,
            name: '9月',
        },{
            id: 10,
            name: '10月',
        },{
            id: 11,
            name: '11月',
        },
    ]);
    const [listAllStar] = useList([
        {
            id: 1,
            name: 'オールスター前',
        },
        {
            id: 2,
            name: 'オールスター後',
        },
    ]);
    const startDate = useMemo(() => {
        if(selected.date.startDate === null) return null;
        return moment(selected.date.startDate, 'YYYY/MM/DD').toDate();
    },[selected.date.startDate])
    const endDate = useMemo(() => {
        if(selected.date.endDate === null) return null;
        return moment(selected.date.endDate,'YYYY/MM/DD').toDate()
    },[selected.date.endDate])
    useEffect(() => {
        if(selected.year.startYear && selected.year.endYear || years.length === 0) return;

        onChange({
            startYear: years[0].id,
            endYear: years[0].id,
        },`${TOTAL_DETAIL.SELECT_PERIOD}.year`)

    }, [years, selected.year]);

    const onMonthChange = useCallback((value) => {
        const arr = [...selected.monthCheck];
        const isInclude = lodash.findIndex(selected.monthCheck, item => item === value.id);
        if(isInclude === -1) {
            arr.push(value.id)
        }else {
            arr.splice(isInclude, 1)
        }
        onChange(arr,`${TOTAL_DETAIL.SELECT_PERIOD}.monthCheck`)
    },[selected.monthCheck])
    const onChangeAllStar = useCallback((value) => {
        const arr = [...selected.checkAllStar];
        const isInclude = lodash.findIndex(selected.checkAllStar, item => item === value.id);
        if(isInclude === -1) {
            arr.push(value.id)
        }else {
            arr.splice(isInclude, 1)
        }
        onChange(arr,`${TOTAL_DETAIL.SELECT_PERIOD}.checkAllStar`)
    },[selected.checkAllStar])

    const onChangeStartDate = useCallback((value) => {
        onChange(value && moment(value).format('YYYY/MM/DD'), `${TOTAL_DETAIL.SELECT_PERIOD}.date.startDate`)
    })
    const onChangeEndDate = useCallback((value) => {
        onChange(value && moment(value).format('YYYY/MM/DD'), `${TOTAL_DETAIL.SELECT_PERIOD}.date.endDate`)
    })
    return <div className='item-group-btn'>
        <h3 className='navbar-item'>期間選択</h3>
        <div className='inner-item-group'>
            <div>
                <div>
                    <label className="radio-detailed-search">年度/月
                        <input type="radio" defaultChecked="checked" name="radio-2" />
                        <span className="checkmark"/>
                    </label>
                </div>
                <div className='select-year-month-detailed-search'>
                    <div>
                        <select className='form-control select-custome' style={{ width: '34%' }}
                                onChange={(e) => onChange(Number(e.target.value), `${TOTAL_DETAIL.SELECT_PERIOD}.year.startYear`)}>
                            {years.map((item,index) => {
                                return  (
                                    <option key={index} value={item.id} selected={item.id === selected.year.startYear}>{item.name}</option>
                                )
                            })}
                        </select>
                        <span>~</span>
                        <select className='form-control select-custome'style={{ width: '34%' }}
                                onChange={(e) => onChange(Number(e.target.value), `${TOTAL_DETAIL.SELECT_PERIOD}.year.endYear`)}>
                            {years.map((item,index) => {
                                return  (
                                    <option key={index} value={item.id} selected={item.id === selected.year.endYear}>{item.name}</option>
                                )
                            })}
                        </select>
                        <div>
                            <label className={'checkbox-allyear'}>
                                <Checkbox name='all-year' checked={selected.allYear} onChange={() => onChange(!selected.allYear, `${TOTAL_DETAIL.SELECT_PERIOD}.allYear`)}/>
                                通算
                            </label>
                        </div>
                    </div>
                    <div>
                        {listMonth.map(item => {
                            const active = selected.monthCheck.includes(item.id);
                            return (
                                <div key={item.id} className={'search-main-advanced-checkbox'}>
                                    <label>
                                        <Checkbox checked={active} onClick={() => onMonthChange(item)}/>
                                        {item.name}
                                    </label>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
            <div>
                <div>
                    <label className="radio-detailed-search">オールスター前後
                        <input type="radio" defaultChecked="checked" name="radio-3" />
                        <span className="checkmark"/>
                    </label>
                </div>
                <div className={'flex-checklist'}>
                    {listAllStar.map((item, index) => {
                        const active = selected.checkAllStar.includes(item.id);
                        return(
                            <div key={item.id} className={'search-main-advanced-checkbox'}>
                                <label className={`label-checklist ${index === 0 ? 'child-m-0' : ''}`}>
                                    <Checkbox checked={active} onClick={() => onChangeAllStar(item)}/>
                                    {item.name}
                                </label>
                            </div>
                        )
                    })}
                </div>
            </div>
            <div>
                <div>
                    <label className="radio-detailed-search">カレンダーで指定
                        <input type="radio" defaultChecked="checked" name="radio-5" />
                        <span className="checkmark"/>
                    </label>
                </div>
                <div>
                    <DatePicker
                        dateFormat="yyyy/MM/dd"
                        selected={startDate}
                        onChange={date => onChangeStartDate(date, TOTAL_DETAIL.SELECT_PERIOD['date.startDate'])}
                        selectsStart
                        startDate={startDate}
                        endDate={endDate}
                        className='time-option'
                        placeholderText="年/月/日"
                        strictParsing
                    />
                    <span>~</span>
                    <DatePicker
                        dateFormat="yyyy/MM/dd"
                        selected={endDate}
                        onChange={date => onChangeEndDate(date, TOTAL_DETAIL.SELECT_PERIOD['date.startDate'])}
                        selectsEnd
                        startDate={startDate}
                        endDate={endDate}
                        minDate={startDate}
                        className='time-option'
                        placeholderText="年/月/日"
                        strictParsing
                    />
                </div>
            </div>
        </div>
    </div>
}

export default SelectPeriod;
